<template>
  <div class="transfer__wrapper">
    <div class="container-header">
      <div class="container-header__title">{{ form.convert ? i18n.lbl_exchange() : i18n.lbl_send() }}</div>
    </div>

    <div class="transfer md-layout md-alignment-center-center">
      <template v-if="!tokenCodes.length">
        <div class="container__no-data">
          <md-card class="container container_40 md-layout-item md-size-100">
            <md-icon class="md-size-4x">send</md-icon>
            <div class="text_large">{{ i18n.tr_no_assets() }}</div>
            <div class="text_description text_margin text_medium">{{ i18n.tr_no_assets_exp() }}</div>
          </md-card>
        </div>
      </template>

      <template v-else-if="view.mode === VIEW_MODES.submit">
        <form novalidate @submit.prevent="processTransfer(true)"
              class="md-layout-item
                     md-size-50
                     md-medium-size-65
                     md-small-size-95
                     md-xsmall-size-100"
        >
          <md-card class="container container_40">
            <md-progress-bar md-mode="indeterminate" v-if="isPending"/>

            <div class="transfer__user-balance text_medium">
              {{ i18n.tr_balance({ balance: swimBalance, token: assetIcon(form.tokenCode) }) }}
            </div>

            <div>
              <!-- <div class="widthdraw__subwallet" v-if="subWalletsFormated.length">
                  <select-field2
                      class="md-layout-item withdraw__select"
                      :label="i18n.lbl_sub()"
                      :values="subWalletsFormated"
                      v-model="activeSubWallet"
                  />
                </div> -->
              <div class="md-layout md-gutter">


                <div v-if="form.convert" class="md-layout-item md-small-size-100">
                  <input-field id="transfer-token"
                               name="token"
                               type="text"
                               v-model="form.tokenCode"
                               :data-vv-as="i18n.lbl_asset()"
                               :label="i18n.lbl_asset()"
                               :readonly="true"
                               @change="tryGetFees"
                  />
                </div>

                <div v-else class="md-layout-item md-small-size-100">
                  <select-field id="transfer-token"
                                @change="checkLimits(), tryGetFees()"
                                name="token"
                                :label="i18n.lbl_choose_asset()"
                                :values="tokenCodes"
                                v-model="form.tokenCode"
                  />
                </div>

                <div class="md-layout-item md-small-size-100 transfer__amount">
                  <input-field id="transfer-amount"
                               class="field__number"
                               name="amount"
                               type="number"
                               v-model="form.amount"
                               v-validate="'required|amount'"
                               :data-vv-as="i18n.lbl_amount()"
                               :label="i18n.lbl_amount()"
                               :readonly="form.convert"
                               @blur="checkAmount"
                               :errorMessage="errorMessage('amount') || (isBalanceExceeded ? i18n.withdraw_error_insufficient_funds() : '')"
                  />
                </div>
              </div>

              <div v-if="!form.convert">{{ allFeesLoaded ? i18n.fees_percent_fixed({ percent: allFees.percent, fixed: allFees.fixed, currency: assetIcon(form.tokenCode) }) : '' }}</div>

              <input-field v-if="!form.convert" id="transfer-recipient"
                           name="recipient"
                           v-model="form.recipient"
                           v-validate="'required|email_or_account_id'"
                           :label="i18n.lbl_recipient_email_or_account()"
                           :readonly="form.convert"
                           :errorMessage="errorMessage('recipient')"
              />
              <div v-if="limitsList"
                   class="transfer__limits-container text_small"
                   :class="{ loading: isFeesLoadPending }">
                <template v-for="(item, key) in limitsList" >
                  <div v-if="item.period === 'operation' || item.period === 'day'" :key="key" :class="{ 'limits-operational': item.period === 'operation'}">
                    <p></p>
                    <p v-if="item.period === 'operation'">{{ i18n.lim_withdrawal_daily_msg1({ limit: item.amount_limit, asset: form.tokenCode }) }}</p>
                    <p v-if="item.period === 'day'">{{ i18n.lim_withdrawal_daily_msg2({ limit: item.amount_limit, asset: form.tokenCode }) }}</p>
                    <p v-if="key === 0">{{ i18n.lim_withdrawal_daily_msg3() }}</p>
                  </div>
                </template>
              </div>
              <textarea-field v-if="!form.convert" id="transfer-description"
                              name="description"
                              v-model="form.subject"
                              v-validate="'max:250'"
                              :label="i18n.lbl_add_note()"
                              :disabled="form.convert"
                              :maxlength="250"
                              :errorMessage="errorMessage('recipient')"
              />
            </div>
            <div class="btn-wrap">
              <template v-if="form.convert" >
                <md-button type="submit" @click="processTransfer()" class="btn md-primary md-yellow w-100" :disabled="isPending">
                  {{ i18n.lbl_exchange() }}
                </md-button>
              </template>
              <template v-else>
                <md-button type="submit" class="btn md-primary md-yellow w-100" :disabled="isBalanceExceeded || isPending">
                  {{ i18n.lbl_send() }}
                </md-button>
              </template>
            </div>
          </md-card>
        </form>
      </template>

      <template v-else-if="view.mode === VIEW_MODES.confirm">
        <confirm-transfer :opts="view.opts"
                          :limitsList="limitsList"
                           class="md-layout-item
                                md-size-50
                                md-medium-size-65
                                md-small-size-100
                                md-xsmall-size-100"
                           :isPending="isPending"
                           @cancel-click="updateView(VIEW_MODES.submit)"
                           @confirm-click="submit"
        />
      </template>

      <template v-if="view.mode === VIEW_MODES.success">
        <md-card class="transfer__success-msg
                        container
                        container_30
                        md-layout-item
                        md-size-50
                        md-medium-size-45
                        md-small-size-100
                        md-xsmall-size-100">
          <md-card-header>
            <div class="md-title">{{ i18n.tr_successful() }}</div>
          </md-card-header>
          <md-card-content>
            <div>
              <div class="transfer__success-amount text_medium">
                {{  swimAmount }} {{ form.tokenCode }}
              </div>
            </div>
          </md-card-content>
          <div class="btn-wrap">
              <md-button class="btn md-primary"
                         @click="form.convert
                          ? goExchange()
                          : updateView(VIEW_MODES.submit, {}, true)">
                {{ i18n.lbl_go_back() }}
              </md-button>
          </div>
        </md-card>
      </template>
    </div>
  </div>

</template>

<script>
  import FormMixin from '@com/mixins/form.mixin'
  import SelectField2 from '@com/fields/SelectField2'
  import CurrencyRound from '@com/mixins/currency.round.mixin'
  import ConfirmTransfer from './Transfers.Confirm'
  import get from 'lodash/get'

  import { ErrorHandler } from '@js/errors/error_handler'
  import { mapGetters, mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { Keypair } from 'tokend-js-sdk'
  import { errors } from '@js/errors/factory'
  import { i18n } from '@js/i18n'
  import { PAYMENT_FEE_SUBTYPES } from '@const'
  import { showAlert } from '@js/modals/alert_message'
  import { usersService } from '@api/users.service'

  import { accountsService } from '@api/accounts.service'
  import { feeService } from '@api/fees.service'
  import { transferService } from '@api/transfers.service'
  import { transactionType } from '@js/const/limits.const'
  import { CurrencyHelper } from '@js/helpers/currency.helper'
  import debounce from 'lodash/debounce'
  import {EventDispatcher} from '@js/events/event_dispatcher'
  // import { withdrawUSDTService } from '@api/withdraw_usdt.service'
  import {isCryptoAsset} from '@utils/consts'

  const VIEW_MODES = {
    submit: 'submit',
    confirm: 'confirm',
    success: 'success'
  }

  export default {
    name: 'transfers-make',
    mixins: [FormMixin, CurrencyRound],
    components: { ConfirmTransfer, SelectField2 },
    data: _ => ({
      form: {
        tokenCode: null,
        amount: '',
        recipient: '',
        subject: '',
        convert: false
      },
      view: {
        mode: VIEW_MODES.submit,
        opts: {}
      },
      // subwallets: null,
      // activeSubWallet: null,
      allFees: {},
      allFeesLoaded: false,
      feesDebouncedRequest: null,
      limitsList: [],
      i18n,
      VIEW_MODES
    }),
    async created () {
      this.setTokenCode()
      this.setAmount()
      this.setRecipient()
      this.setSubject()
      this.setConvert()
      this.loadCurrentBalances()
      this.checkLimits()
      this.tryGetFees()
      // await this.getSubWallets()
    },
    computed: {
      ...mapGetters([
        vuexTypes.accountBalances,
        vuexTypes.userTransferableTokens,
        vuexTypes.accountSignerName,
        vuexTypes.accountTypeI,
        vuexTypes.accountType,
        vuexTypes.factorData,
        vuexTypes.accountId
      ]),
      // subWalletsFormated () {
      //   if (this.subwallets) {
      //     return this.subwallets.filter(el => el.Asset === this.form.tokenCode)
      //   }
      //   return []
      // },
      swimAmount () {
        if (isCryptoAsset(this.form.tokenCode)) {
          return this.roundCurrency2(this.form.amount, this.form.tokenCode)
        }
        return this.roundCurrency(this.form.amount, this.form.tokenCode)
      },
      swimBalance () {
        if (isCryptoAsset(this.form.tokenCode)) {
          return this.roundCurrency2(this.balance.balance, this.form.tokenCode)
        }
        return this.roundCurrency(this.balance.balance, this.form.tokenCode)
      },
      // subWalletBalance () {
      //   if (this.activeSubWallet) {
      //     return this.subWalletsFormated.find(el => el.WalletId === this.activeSubWallet)
      //   }
      //   return false
      // },
      tokenCodes () {
        return this.userTransferableTokens.map(token => token.code)
      },
      balance () {
        return this.accountBalances[this.form.tokenCode]
      },
      isBalanceExceeded () {
        return Number(this.form.amount) > Number(get(this.balance, 'balance') || 0)
      },
      operational () {
        let name = this.accountSignerName
        if (name) {
          name = name.toLowerCase()
          return name.startsWith('commission') || name.startsWith('operation')
        }
        return false
      },
      nofees () {
        return this.operational || this.form.convert
      }
    },
    methods: {
      ...mapActions({
        loadCurrentBalances: vuexTypes.GET_ACCOUNT_BALANCES,
        updateTwoFactorData: vuexTypes.SET_TWO_FACTOR_STATE
      }),
      // async getSubWallets () {
      //   const {_parsedData: res} = await withdrawUSDTService.getSubWallets({
      //     user_id: this.accountId
      //   })
      //   this.subwallets = res
      //   this.subwallets = this.subwallets.map(el => {
      //     return {
      //       ...el,
      //       Balance: el.Balance / 1000000
      //     }
      //   })
      // },
      async submit (feeFromSource) {
        this.disable()
        const sub = this.subWalletBalance
        try {
          await transferService.createTransfer({
            ...this.view.opts,
            feeFromSource,
            sub_wallet_id: sub ? sub.WalletId : null,
            asset: this.form.tokenCode,
            convert: this.convert
          })
          if (this.form.convert && this.view.mode === VIEW_MODES.submit) {
            this.updateView(VIEW_MODES.success, feeFromSource)
          } else {
            this.view.mode = VIEW_MODES.success
          }
          await this.loadCurrentBalances()
        } catch (error) {
          this.view.mode = this.form.convert ? VIEW_MODES.submit : VIEW_MODES.confirm
          if (error instanceof errors.TFAExceededCodeError) {
            EventDispatcher.dispatchShowErrorEvent(i18n.tfa_to_many_attempts())
          } else {
            ErrorHandler.processUnexpected(error)
          }
        }

        this.enable()
      },
      tryGetFees () {
        this.allFees = {}
        this.allFeesLoaded = false
        if (!this.feesDebouncedRequest) {
          this.feesDebouncedRequest = debounce(() => this.getFees(), 300)
        }
        return this.feesDebouncedRequest()
      },
      async getFees () {
        try {
          await feeService.loadPaymentFeeByAmount(this.form.tokenCode, this.form.amount)
          const getAllFees = await feeService.loadAccountFees()
          Object.values(getAllFees)
            .forEach(fees => fees.forEach(fee => {
              if (this.allFees.percent > 0 || this.allFees.fixed > 0) return
              if (fee.asset === this.form.tokenCode && fee.fee_type === 0) {
                this.allFees = {
                  percent: this.roundCurrency(fee.percent, this.form.tokenCode),
                  fixed: this.roundCurrency(fee.fixed, this.form.tokenCode)
                }
              }
            }))
          this.allFeesLoaded = true
        } catch (err) {
          this.allFeesLoaded = false
        }
      },
      amountGreaterThanBalance (amount, srcFees, dstFees, balance, payForDst = false) {
        let commissions = Number(srcFees.percent) + Number(srcFees.fixed)
        if (payForDst) commissions = commissions + Number(dstFees.percent) + Number(dstFees.fixed)
        const greaterPlusCommissions = commissions + Number(amount) > Number(balance)
        const greater = Number(amount) > Number(balance)
        if (greater) {
          showAlert({
            title: i18n.tr_sending_error(),
            message: i18n.tr_greater_than_balance()
          })
          return true
        } else if (greaterPlusCommissions) {
          showAlert({
            title: i18n.tr_sending_error(),
            message: i18n.tr_greater_amount_and_commissions()
          })
          return true
        }
        return false
      },
      assetIcon (asset) {
        return CurrencyHelper.getCurrencyIcon(asset)
      },
      async processTransfer (preventSubmit = false) {
        if (preventSubmit && this.form.convert) return
        if (!await this.isValid()) return
        this.disable()
        try {
          const counterparty = await this.loadCounterparty()
          const fees = await this.loadFees(counterparty.accountId)
          if (this.amountGreaterThanBalance(
            this.form.amount,
            fees.source,
            fees.destination,
            this.roundCurrency(this.balance.balance, this.form.tokenCode))) {
            this.enable()
            return
          }

          const opts = {
            amount: this.form.amount,
            destinationAccountId: counterparty.accountId,
            destinationEmail: counterparty.email,
            destinationFixedFee: fees.destination.fixed,
            destinationPercentFee: fees.destination.percent,
            destinationFeeAsset: fees.destination.feeAsset,
            sourceBalanceId: this.balance.balance_id,
            sourceBalance: this.roundCurrency(this.balance.balance, this.form.tokenCode),
            sourceFixedFee: fees.source.fixed,
            sourcePercentFee: fees.source.percent,
            sourceFeeAsset: fees.source.feeAsset,
            subject: this.form.subject,
            tokenCode: this.form.tokenCode
          }

          if (this.form.convert && this.view.mode === VIEW_MODES.submit) {
            this.view.opts = opts
            await this.submit(opts)
          } else {
            this.updateView(VIEW_MODES.confirm, opts)
          }
        } catch (error) {
          console.error(error)
          if (error instanceof errors.NotFoundError) {
            error.showBanner(i18n.tr_recipient_not_found())
            this.enable()
            return
          }
          ErrorHandler.processUnexpected(error)
        }
        this.enable()
      },
      async loadCounterparty () {
        const counterparty = {}
        const providedRecipient = this.form.recipient
        if (Keypair.isValidPublicKey(providedRecipient)) {
          counterparty.accountId = providedRecipient
          counterparty.email = await accountsService.loadEmailByAccountId(providedRecipient)
          return counterparty
        }
        counterparty.email = providedRecipient
        counterparty.accountId = await accountsService.loadAccountIdByEmail(providedRecipient)
        return counterparty
      },
      async loadFees (recipientAccountId) {
        const fees = { source: {}, destination: {} }
        const [ senderFees, recipientFees ] = await Promise.all([
          feeService.loadPaymentFeeByAmount(this.form.tokenCode, this.form.amount),
          feeService.loadPaymentFeeByAmount(this.form.tokenCode, this.form.amount, recipientAccountId, PAYMENT_FEE_SUBTYPES.incoming)
        ])
        fees.source.fixed = this.nofees ? 0 : senderFees.fixed
        fees.source.percent = this.nofees ? 0 : senderFees.percent
        fees.source.feeAsset = senderFees.feeAsset
        fees.destination.fixed = this.nofees ? 0 : recipientFees.fixed
        fees.destination.percent = this.nofees ? 0 : recipientFees.percent
        fees.destination.feeAsset = recipientFees.feeAsset
        return fees
      },
      async updateView (mode, opts = {}, clear = false) {
        this.view.mode = mode
        this.view.opts = opts
        if (clear) {
          this.clear()
          this.setTokenCode()
          this.setConvert()
          // await this.getSubWallets()
        }
      },
      goExchange () {
        this.$router.push({
          name: 'Exchange.Index'
        })
      },
      setTokenCode () {
        this.form.tokenCode = this.$route.params.tokenCode || this.tokenCodes[0] || null
      },
      setAmount () {
        this.form.amount = this.$route.params.amount || ''
      },
      checkAmount () {
        if (isCryptoAsset(this.form.tokenCode)) {
          this.form.amount = this.form.amount ? this.roundCurrency2(this.form.amount, this.form.tokenCode) : null
        } else {
          this.form.amount = this.form.amount ? this.roundCurrency(this.form.amount, this.form.tokenCode) : null
        }
      },
      setRecipient () {
        this.form.recipient = this.$route.params.recipient || ''
      },
      setSubject () {
        this.form.subject = this.$route.params.subject || ''
      },
      setConvert () {
        this.form.convert = this.$route.params.convert || false
      },
      async checkLimits () {
        this.limitsList = await usersService.getLimit(this.form.tokenCode, transactionType.transfer)
      }
    },
    watch: {
      'form.tokenCode' () {
        this.activeSubWallet = null
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';

  .w-100 {
    width: 100%;
  }

  .transfer__amount {
    position: relative;

    &-error {
      bottom: -24px;
    }
  }

  .transfer__user-balance {
    margin-bottom: 24px;
    color: $default-black;
  }

  .transfer__success-msg {
    text-align: center;
  }

  .transfer__success-amount {
    color: $col-md-primary;
    margin: 1rem 0 .5rem;
  }

  .payment-form__list {
    list-style-type: none;
  }

  /deep/ .transfer__limits-container {
    display: flex;
    flex-direction: column;
    color: $col-text-secondary;
    margin-bottom: 12px;
  }

  /deep/ .limits-operational {
    order: -1;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/transfers/make/Transfers.Make.vue